/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setSelectedImage, setPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
import { clearImageTab } from 'state/actions/embedsState/embedManagementState/image_status';
// component
import ImageAPI from 'material/embeds/imageapi/imageapi';



/* ========== ~~~~~~~~~~ IMAGE API : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection, // background, questionImage, option_0, option_1, option_2, option_3
    clientUUID: sessionStatus.clientUUID, // client ID used to make call for users uploaded images
    newUpload: embedsState.embedManagementState.contentStatus.newUpload,
    pageCount: embedsState.embedManagementState.imageStatus.page_count,
    mocked: sessionStatus.mocked
});

const mapDispatchToProps = dispatch => ({
    setSelectedImage: (provider, imageId, imageURL) => dispatch(setSelectedImage(provider, imageId, imageURL)),// provider: USAToday, SIPA
    setPreviewImage: imageURL => dispatch(setPreviewImage(imageURL)),
    clearImageTab: () => dispatch(clearImageTab())
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageAPI);
